export function first(map) {
    return Array.from(map.values())[0];
}
